// Best-effort patient name for the encounter a recording is attached to. The chat
// may not be loaded (an old or cross-session recording) — in that case we omit the
// name rather than guess. Shared by the Local Recordings manager and the sign-in
// backlog alert so an exported filename reads the same whichever offered it.
export function patientNameForChat(chats, chatId) {
  if (!chatId || !Array.isArray(chats)) return "";
  const chat = chats.find((c) => c && c.id === chatId);
  if (!chat) return "";
  // Loaded encounters carry the patient name under `chat.user` (see ChatList);
  // a freshly-built quickstart chat uses `chat.patient`.
  const p = chat.user || chat.patient;
  if (!p) return "";
  return `${p.firstName || ""} ${p.lastName || ""}`.trim();
}

// The patient a queued recording was MADE for. Encounter ids are recycled after hard
// deletes, so the chat lookup above can name a different patient than the one on the
// audio; the label stored on the row at record time always wins. `fromEncounter`
// says the name came from that lookup (rows queued before capture have no label).
export function patientForRecording(chats, recording) {
  const stored = recording && typeof recording.patientLabel === "string" ? recording.patientLabel.trim() : "";
  if (stored) return { name: stored, fromEncounter: false };
  const looked = patientNameForChat(chats, recording && recording.chatId);
  return { name: looked, fromEncounter: !!looked };
}
